module.exports = __webpack_public_path__ + "img/pascal_luka_rave_ocular.69285ad4.jpg";